<script lang="ts">
  import moneyFormatters from "@shared/filters/money.js";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let productId: number;
  export let containerDeposit: number;
  export let containerType: string;
  export let containerCount: number;
  export let includedInPrice = false;

  const isEligibleForDeposit = ["keg", "bottle", "can", "item"].includes(containerType);

  const containerDepositPerUnit = () => {
    return containerDeposit / containerCount;
  };

  $: formattedTotalContainerDeposit = moneyFormatters
    .filter()(containerDeposit)
    .replace(/\.00$/, "");
  $: formattedContainerDeposit = moneyFormatters
    .filter()(containerDepositPerUnit())
    .replace(/\.00$/, "");

</script>

<style>
  .fizz-tooltip-trigger {
    border-bottom: 1px dashed currentColor;
    font-weight: inherit;
  }

</style>

{#if containerDeposit && isEligibleForDeposit}
  <div
    class="fizz-tooltip-container fizz-flex-row-4 fizz-text-subdued fizz-text-small fizz-align-content-start"
    data-testid="container-deposit-string"
  >
    <Icon type="CreditsColor" fill="#595959" height="20" width="12" />
    <p
      class="fizz-tooltip-trigger fizz-underline-dashed"
      aria-describedby="tooltip-container-deposit-{productId}"
    >
      {formattedTotalContainerDeposit}
      {containerType} deposit {#if includedInPrice}applied{/if}
    </p>
    <div
      class="fizz-tooltip"
      role="tooltip"
      style="--max-width: 190px;"
      id="tooltip-container-deposit-{productId}"
    >
      {#if includedInPrice}
        {formattedTotalContainerDeposit} applied to total ({formattedContainerDeposit}/{containerType})
      {:else}
        {formattedTotalContainerDeposit} applied on final invoice ({formattedContainerDeposit}/{containerType})
      {/if}
    </div>
  </div>
{/if}
